import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 0,
  class: "combo_box"
};
const _hoisted_3 = ["onClick"];
import BaseButton from '@/templates/argon-core/BaseButton';
import { ref, toRefs } from 'vue';
export default {
  __name: 'AppgBaseButton',
  props: {
    _class: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'default'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: [String],
      default: () => '',
      required: false
    },
    value: {
      type: [Array, String, Object],
      default: () => ''
    },
    size: {
      type: String,
      default: ''
    },
    comboBox: {
      type: Array,
      default: () => [],
      validator(value) {
        if (!Array.isArray(value)) return false;
        if (value.length > 0) {
          const val = value[0];
          const keys = Object.keys(val);
          return keys.includes('label') && keys.includes('value');
        }
        return true;
      }
    }
  },
  emits: ['click'],
  setup(__props, {
    emit: __emit
  }) {
    const UUID = ref(Math.floor(Math.random() * 9999));
    const props = __props;
    const {
      type,
      disabled,
      label,
      value,
      comboBox
    } = toRefs(props);
    const emit = __emit;
    const click = (work = true, value, subValue) => {
      if (!work) return;
      emit('click', value, subValue);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(BaseButton), {
        class: _normalizeClass(__props._class),
        onClick: _cache[0] || (_cache[0] = $event => click((_unref(comboBox)?.length ?? []) === 0, _unref(value))),
        disabled: _unref(disabled),
        type: _unref(type),
        size: __props.size,
        key: `button_${UUID.value}`
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, () => [_createElementVNode("span", null, [_createElementVNode("span", null, _toDisplayString(_unref(label)), 1), _unref(comboBox).length !== 0 ? (_openBlock(), _createElementBlock("span", _hoisted_1, "▼")) : _createCommentVNode("", true)]), _unref(comboBox).length !== 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(comboBox), (comboItem, comboIndex) => {
          return _openBlock(), _createElementBlock("li", {
            onClick: _withModifiers($event => click(_unref(comboBox).length > 0, _unref(value), comboItem.value), ["stop"]),
            class: "border border-radius-lg",
            key: `combo_${comboIndex}_${UUID.value}`
          }, _toDisplayString(comboItem.label), 9, _hoisted_3);
        }), 128))])) : _createCommentVNode("", true)])]),
        _: 3
      }, 8, ["class", "disabled", "type", "size"]);
    };
  }
};